// The Freaks strings — copied 1:1 from mobile translations/en.json (theFreaks + its settings keys).
// Keep in sync with mobile: same keys, same %{param} placeholders.
export default {
  "theFreaks": {
    "profile": {
      "notPlaying": "Not playing yet — tap to start and earn respect",
      "toNextLevel": "%{respect} respect to Lvl %{level}",
      "seasonRank": "Season rank",
      "record": "%{missions} missions · %{won} won · %{lost} lost",
      "maxLevel": "Top level reached — you are a Lvl %{level} freak!"
    },
    "title": "The Freaks",
    "homeButton": "Freaks",
    "botBadge": "BOT",
    "botA11y": "Computer player, not a real person",
    "homeButtonA11y": "Open The Freaks game",
    "tagline": "Do your thing, earn respect, top the board",
    "level": "Lvl %{level}",
    "levelMax": "Lvl %{level} · MAX",
    "power": "Power",
    "respect": "Respect",
    "cash": "Cash",
    "energy": "Energy",
    "nextEnergy": "+1 in %{time}",
    "energyFull": "Full",
    "playAs": "Playing as",
    "pickContext": "Pick your activity",
    "pickContextHint": "Missions, gear and base follow your activity. Gear you bought stays with its activity.",
    "refill": "Campfire snack +%{energy}",
    "refillPrice": "%{price} cash · %{left} left today",
    "recoveryTitle": "Injured — recovering",
    "recoveryText": "Missions and challenges are back in %{time}",
    "recoverButton": "Patch up for %{price}",
    "rulesTitle": "How to play",
    "rules": "Energy refills by itself (+1 every 3 min). Spend it on missions to earn cash and respect. Each stat has a job: Skill for missions, Strength to challenge, Endurance to defend (and shorter injuries), Charisma for base income. Better gear and base levels unlock as your level grows, all the way to Lvl 100. Build a base that earns cash while you're away. Challenge other freaks to take some of their cash. New players are protected for their first 7 days (or until 200 respect) and can challenge bots only. Claim the daily prize every day — the top 3 freaks of each day win real Freak Points. Finish 3 daily quests (one done for real in Freakland). Check today's world event. Repair your base when it wears out and keep cash in the Safe. Each month's top 10 and the best of each activity win medals. Players marked BOT are computer players: they keep the game busy, can be challenged like anyone and never win Freak Points. Every activity has its own freak character that evolves through 12 stages as your level grows — from clueless rookie to legend, and on to a level-100 deity.",
    "daily": {
      "title": "Daily prize",
      "streak": "Day %{streak} of 7",
      "prize": "%{cash} cash + %{energy} energy",
      "points": "+%{points} FP",
      "claim": "Claim",
      "bonusOn": "Freak bonus: cash doubled for publishing a freak today 🔥",
      "bonusTip": "Publish a freak today to double the cash",
      "claimed": "Prize claimed. Come back tomorrow to keep your streak!"
    },
    "tabs": {
      "missions": "Missions",
      "train": "Train",
      "gear": "Gear",
      "base": "Base",
      "fight": "Fight",
      "top": "Top Freaks",
      "today": "Freakland today",
      "friends": "Friends",
      "quests": "Quests"
    },
    "quests": {
      "intro": "3 new quests every day: two in the game and one you do for real in Freakland. Finish them and tap \"Claim\".",
      "names": {
        "missions": "Win %{goal} missions",
        "bigMission": "Win a tier 3+ mission",
        "challenge": "Win a challenge",
        "train": "Train %{goal} times",
        "collect": "Collect your base",
        "realFreak": "Publish a freak today",
        "realTrack": "Record a track today",
        "realCatch": "Log a catch today",
        "realReel": "Post a reel today"
      },
      "realHint": "Do it in Freakland — it counts by itself",
      "reward": "+%{cash} cash · +%{respect} respect",
      "points": "+%{points} FP",
      "claim": "Claim",
      "claimed": "Claimed"
    },
    "awards": {
      "title": "My medals & badges",
      "hint": "Medals for each month's top 10 and the best of each activity (top 3 win 100 / 50 / 25 FP). Badges for streaks, missions and friends who join.",
      "empty": "Nothing yet — finish the month in the top 10 or keep a streak going.",
      "names": {
        "season1": "Season champion",
        "season2": "Season runner-up",
        "season3": "Season 3rd place",
        "seasonTop10": "Season top 10",
        "activityChampion": "Best in the activity",
        "dailyChampion": "Daily champion",
        "streak30": "30-day streak",
        "winStreak5": "5 wins in a row",
        "winStreak10": "10 wins in a row",
        "missions100": "100 missions",
        "missions1000": "1000 missions",
        "recruiter": "Recruiter",
        "other": "Award"
      }
    },
    "world": {
      "title": "Today in Freakland",
      "payday": "Payday: missions pay 25% more cash",
      "luckyDay": "Lucky day: +10% chance on every mission",
      "trainingCamp": "Training camp: training costs 25% less",
      "fightNight": "Fight night: challenge wins take 50% more",
      "boomingBusiness": "Booming business: bases earn 50% more",
      "hotActivity": "Hot activity: %{context} — its missions give 50% more respect"
    },
    "safe": {
      "title": "Safe",
      "balance": "%{cash} / %{capacity} cash inside",
      "hint": "Cash in the safe can't be taken in challenges. Deposits cost %{fee}%, withdrawals are free, +%{interest}% interest every new month. It holds more as your level grows.",
      "depositAll": "Deposit all",
      "withdrawAll": "Withdraw all"
    },
    "missions": {
      "go": "Go",
      "tier": "Tier %{tier}",
      "chance": "%{chance}% chance",
      "reward": "~%{cash} cash · +%{respect} respect",
      "locked": "Unlocks at %{respect} respect",
      "energy": "%{energy} energy",
      "repeat": "Repeat ×%{times}",
      "showLocked": "Show %{count} locked missions",
      "hideLocked": "Hide locked missions"
    },
    "stats": {
      "strength": "Strength",
      "skill": "Skill",
      "endurance": "Endurance",
      "charisma": "Charisma"
    },
    "statHints": {
      "strength": "Main stat when you challenge someone",
      "skill": "Main stat for missions",
      "endurance": "Main stat when you're challenged · shorter injuries",
      "charisma": "+1% base income per point"
    },
    "statEffects": {
      "endurance": "Injuries %{percent}% shorter",
      "charisma": "Base income +%{percent}%"
    },
    "train": {
      "button": "Train",
      "cost": "%{price} cash · %{energy} energy",
      "withGear": "%{value} with gear",
      "powers": "Power · Missions %{missions} · Attack %{attack} · Defence %{defense}",
      "powersHint": "Each action counts its main stat double. Train evenly or specialise."
    },
    "gear": {
      "buy": "Buy · %{price}",
      "owned": "Owned",
      "bonus": "+%{bonus} %{stat}",
      "locked": "Unlocks at Lvl %{level}",
      "showLocked": "Show %{count} locked gear",
      "hideLocked": "Hide locked gear"
    },
    "base": {
      "level": "Level %{level}/%{max}",
      "notBuilt": "Not built yet — it earns cash while you're away",
      "income": "%{income} cash / hour",
      "waiting": "Waiting: %{cash} cash (holds %{hours} h)",
      "collect": "Collect",
      "build": "Build · %{price}",
      "upgrade": "Upgrade · %{price}",
      "nextIncome": "Next level: %{income} cash / hour",
      "maxed": "Max level reached",
      "condition": "Condition %{condition}%",
      "worn": "Worn out — it earns less. Repair it!",
      "repair": "Repair · %{price}",
      "locked": "Next level unlocks at Lvl %{level}"
    },
    "fight": {
      "intro": "Challenge a freak with similar respect. Win and take 10% of their cash. Each freak can only be challenged 3 times a day. Challenge the same freak more than 3 times a week and the loot shrinks.",
      "challenge": "Challenge",
      "cost": "%{energy} energy",
      "record": "Won %{won} · Lost %{lost}",
      "empty": "No one to challenge right now — come back later.",
      "refresh": "Find others",
      "loot": "%{percent}% loot",
      "newcomer": "🛡️ Newcomer protection until %{date}: nobody can challenge you and you can challenge bots only. It ends early at 200 respect."
    },
    "top": {
      "season": "This month",
      "today": "Today",
      "all": "All time",
      "allContexts": "All",
      "myRank": "You: #%{rank} · %{score} respect",
      "unranked": "Earn respect to get on this board",
      "score": "%{score}",
      "empty": "Nobody here yet. Be the first!",
      "prizeInfo": "Top 3 of each day win 30 / 20 / 10 Freak Points",
      "seasonPrize": "Top 3 of the month win 100 / 50 / 25 FP and a medal"
    },
    "today": {
      "yesterday": "Yesterday in Freakland",
      "freaks": "new freaks",
      "reels": "new reels",
      "catches": "catches",
      "busiest": "Busiest",
      "topFreak": "Freak of the week",
      "likes": "%{count} likes",
      "champions": "Yesterday's champions",
      "championPrize": "+%{points} FP",
      "events": "What's going on",
      "noEvents": "Quiet for now. Go make some noise!"
    },
    "friends": {
      "intro": "Invite friends — people you follow who follow you back — to play The Freaks. They get a push with your invitation.",
      "invite": "Invite",
      "invitedToday": "Invited",
      "invited": "Invitation sent to @%{username} 🎮",
      "playing": "Plays The Freaks",
      "notPlaying": "Not playing yet",
      "empty": "No friends yet. Friends are people you follow who follow you back.",
      "limit": "You can invite each friend once a day."
    },
    "events": {
      "mission": "completed %{name}",
      "challengeWon": "beat %{target}",
      "challengeLost": "lost to %{target}",
      "gear": "bought %{name}",
      "base": "upgraded %{name} to level %{level}",
      "champion": "was #%{rank} yesterday (+%{points} FP)",
      "medal": "won %{award} (%{season})",
      "badge": "earned %{award}"
    },
    "results": {
      "missionWon": "%{name}: done! +%{cash} cash, +%{respect} respect",
      "missionFailed": "%{name}: didn't work out this time",
      "missionInjured": "%{name}: injured! Recovering for %{minutes} min",
      "trained": "%{stat} is now %{value}",
      "gearBought": "%{name} is yours",
      "baseUpgraded": "%{name}: level %{level}",
      "collected": "+%{cash} cash collected",
      "refilled": "+%{energy} energy",
      "recovered": "Back in action!",
      "dailyClaimed": "+%{cash} cash, +%{energy} energy",
      "dailyPoints": "+%{points} Freak Points!",
      "challengeWon": "You beat %{opponent}! +%{cash} cash, +%{respect} respect",
      "challengeLost": "%{opponent} was stronger this time",
      "contextChanged": "Now playing: %{context}",
      "missionRepeat": "%{name} ×%{runs}: %{wins} won, +%{cash} cash, +%{respect} respect",
      "questClaimed": "Quest done! +%{cash} cash, +%{respect} respect",
      "repaired": "Base repaired for %{cash} cash",
      "deposited": "%{deposited} cash in the safe (fee %{fee})",
      "withdrawn": "%{withdrawn} cash taken out of the safe",
      "lootReduced": "You've challenged them a lot this week: %{percent}% loot"
    },
    "errors": {
      "not_enough_energy": "Not enough energy. Wait a bit or grab a campfire snack.",
      "not_enough_cash": "Not enough cash",
      "recovering": "You're still recovering",
      "locked": "Earn more respect to unlock this",
      "already_owned": "You already have it",
      "max_level": "Already at max level",
      "no_base": "Build your base first",
      "no_refills_left": "No snacks left today",
      "energy_full": "Your energy is already full",
      "not_recovering": "You're not injured",
      "target_protected": "This freak has been challenged enough today",
      "already_claimed": "Already claimed today",
      "already_challenged": "You already challenged this freak today",
      "busy": "Too fast! Try again",
      "already_invited": "You already invited this friend today — try again tomorrow",
      "not_friends": "You can only invite friends (you follow each other)",
      "quest_not_done": "Finish the quest first",
      "unknown_quest": "This quest isn't available today",
      "no_repair_needed": "Your base is like new",
      "safe_full": "Your safe is full — level up for more room",
      "not_enough_in_safe": "There isn't that much in your safe",
      "invalid_amount": "Pick an amount",
      "level_locked": "Reach a higher level to unlock this",
      "newcomer_bots_only": "You're still a newcomer: challenge bots until your protection ends",
      "target_newcomer": "This freak is a newcomer and is protected for now",
      "generic": "Something went wrong. Try again."
    },
    "loadError": "Couldn't load The Freaks. Pull to retry.",
    "character": {
      "title": "My freak",
      "stage": "STAGE %{stage}/%{stages}",
      "next": "Next: %{name} at Lvl %{level}",
      "legend": "Level 100 — the ultimate freak. Nothing left to evolve into!",
      "locked": "unlocks at Lvl %{level}",
      "evolved": "🎉 Your freak evolved into %{name}!"
    }
  },
  "settings": {
    "theFreaksDailyNotification": "🎁 The Freaks: daily prize & champions",
    "theFreaksChallengeNotification": "🥊 The Freaks: challenges",
    "theFreaksInviteNotification": "🎮 The Freaks: friend invitations",
    "theFreaksOnProfile": "Show The Freaks on my profile",
    "theFreaksOnProfileDescription": "Your level, season rank and record in the Statistics section of your profile"
  }
};
